module.exports = __webpack_public_path__ + "img/login-logo.a6f050fe.svg";